import React from 'react'
import { useLocation } from 'react-router-dom'

const COMING_SOON = {
  '/admin/recurring/confirmation': {
    title: 'Vakiovuorojen ostot ja vahvistukset',
    body: 'Tällä sivulla pääset hallitsemaan vakiovuorosopimuksiin liittyviä ostoja ja vahvistuksia. Toiminto otetaan käyttöön myöhemmin.',
  },
  '/admin/proshop/orders': {
    title: 'Tuotetilausten hallinta',
    body: 'Tällä sivulla pystyt seuraamaan ja käsittelemään verkkokaupan tuotetilauksia. Toiminto otetaan käyttöön myöhemmin.',
  },
  '/admin/leagues': {
    title: 'Hallisarjat',
    body: 'Tällä sivulla pystyt suunnittelemaan ja hallinnoimaan hallisarjoja. Toiminto otetaan käyttöön myöhemmin.',
  },
}

const TBDContainer = () => {
  const location = useLocation()
  const info = COMING_SOON[location.pathname] || {
    title: 'Tulossa pian',
    body: 'Tämä toiminto otetaan käyttöön myöhemmin.',
  }
  return (
    <div className='content'>
      <div className='p-5 mb-4 rounded-3' style={{ background: 'rgba(256, 256, 256, 0.3)' }}>
        <h4 className='display-4'>{info.title}</h4>
        <hr className='my-2' />
        <p className='lead'>{info.body}</p>
      </div>
    </div>
  )
}

export default TBDContainer
